import { DistributionType } from '../../../../src/app/modules/domain/enums/distribution-type';

export class PopupData {
    addressId: string;
    street: string;
    houseNumber: string;
    city: string;
    postalCode: string;
    weight: number;
    type: DistributionType;
    lastModified: string;
    lastModifiedBy: string;

    constructor();
    constructor(json: any);
    constructor(json?: PopupData) {
        if (json) {
            this.addressId = json.addressId;
            this.street = json.street;
            this.houseNumber = json.houseNumber;
            this.city = json.city;
            this.postalCode = json.postalCode;
            this.weight = json.weight;
            this.type = json.type;
            this.lastModified = json.lastModified;
            this.lastModifiedBy = json.lastModifiedBy;
        }
    }
}



// WEBPACK FOOTER //
// ./libs/map/components/update-popup/popup-data.ts